import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GetDataService } from '../../../services/userService/get-data.service';
import { LoaderComponent } from '../../../Common/loader/loader.component';
import { Contents } from '../../../Common/rules.module';

@Component({
  selector: 'app-displayrules',
  imports: [CommonModule, FormsModule,LoaderComponent],
  templateUrl: './displayrules.component.html',
  styleUrl: './displayrules.component.scss'
})
export class DisplayrulesComponent {
  rules: Contents[] = [];
  // data: Contents[] = [];

  constructor(private _activeRoute: ActivatedRoute, private _route: Router, private _service: GetDataService) { }

  sectionId: any;
  ngOnInit() {
    this.sectionId = this._activeRoute.snapshot.paramMap.get("id");
    this._service.getData().subscribe(
      data => {
        this.rules = data.filter((rule: any) => rule.id == this.sectionId);
      },
      error => {
        console.error("Error fetching rules:",error);
      }
    );
  }

  abandonRule(ruleId: any) {
    this._route.navigate([`admin/section/${this.sectionId}/${ruleId}`]);
  }

  goBack() {
    this._route.navigate(['/admin']);
  }
}
